import { render, staticRenderFns } from "./org-create.vue?vue&type=template&id=1768fd06&"
import script from "./org-create.vue?vue&type=script&lang=js&"
export * from "./org-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports